import React from "react";
import IOSSwitch from "../IsoSwitch";
import { FormGroup, FormControlLabel } from "@mui/material";

function CustomSwitch({
  checked,
  onChange,
  label,
  switchProps,
  defaultChecked,
  formProps,
  labelProps,
}) {
  return (
    <FormGroup {...formProps}>
      <FormControlLabel
        {...labelProps}
        control={
          <IOSSwitch
            checked={checked}
            onChange={onChange}
            defaultChecked={defaultChecked}
            {...switchProps}
          />
        }
        label={label}
      />
    </FormGroup>
  );
}

export default CustomSwitch;
